var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        width: "1000px",
        "custom-class": "channel-dialog__wrap",
        title: "选择渠道",
        visible: _vm.visible,
        "close-on-click-modal": false,
        "append-to-body": _vm.isAppendToBody,
        "modal-append-to-body": _vm.modelIsAppendToBody,
      },
      on: { open: _vm.handleOpen, close: _vm.handleClose },
    },
    [
      _c("div", { staticClass: "popups-inner__body" }, [
        _c(
          "div",
          { staticClass: "popups-from__wrap" },
          [
            _c(
              "el-form",
              {
                attrs: {
                  size: _vm.formSize,
                  inline: "",
                  model: _vm.channelQuery,
                },
              },
              [
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "请选择设备类型" },
                        model: {
                          value: _vm.channelQuery.businessType,
                          callback: function ($$v) {
                            _vm.$set(_vm.channelQuery, "businessType", $$v)
                          },
                          expression: "channelQuery.businessType",
                        },
                      },
                      _vm._l(_vm.deviceTypes, function (item) {
                        return _c("el-option", {
                          key: item.dictKey,
                          attrs: { label: item.dictValue, value: item.dictKey },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "请选择平台类型" },
                        model: {
                          value: _vm.channelQuery.platformType,
                          callback: function ($$v) {
                            _vm.$set(_vm.channelQuery, "platformType", $$v)
                          },
                          expression: "channelQuery.platformType",
                        },
                      },
                      _vm._l(_vm.platformTypes, function (item) {
                        return _c("el-option", {
                          key: item.dictKey,
                          attrs: { label: item.dictValue, value: item.dictKey },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c("el-input", {
                      attrs: { clearable: "", placeholder: "渠道名称/APPID" },
                      model: {
                        value: _vm.channelQuery.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.channelQuery, "name", $$v)
                        },
                        expression: "channelQuery.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          loading: _vm.channelListLoading,
                          icon: "el-icon-search",
                          type: "primary",
                        },
                        on: { click: _vm.handleSearch },
                      },
                      [_vm._v("搜索")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          loading: _vm.channelListLoading,
                          type: "primary",
                        },
                        on: { click: _vm.forceUpdate },
                      },
                      [_vm._v("强制刷新")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.channelListLoading,
                expression: "channelListLoading",
              },
            ],
            staticClass: "channel-table",
            attrs: {
              "element-loading-text": "拼命加载中",
              "element-loading-spinner": "el-icon-loading",
            },
          },
          [
            _vm.visibleLazyTable
              ? _c(
                  "lazyTable",
                  { ref: "lazyTable", attrs: { data: _vm.list } },
                  [
                    _vm.multiple
                      ? _c("el-table-column", {
                          attrs: { label: "测试", width: "50px" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-checkbox",
                                      {
                                        attrs: {
                                          indeterminate: _vm.indeterminate,
                                        },
                                        on: { change: _vm.handleSelectAll },
                                        model: {
                                          value: _vm.checked,
                                          callback: function ($$v) {
                                            _vm.checked = $$v
                                          },
                                          expression: "checked",
                                        },
                                      },
                                      [_vm._v(_vm._s(" "))]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-checkbox",
                                      {
                                        attrs: { value: scope.row.checked },
                                        on: {
                                          change: (checked) =>
                                            _vm.handleSelectChange(
                                              scope.row,
                                              checked
                                            ),
                                        },
                                      },
                                      [_vm._v(_vm._s(" "))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            319820284
                          ),
                        })
                      : _vm._e(),
                    !_vm.multiple
                      ? _c("el-table-column", {
                          attrs: { width: "50px" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-radio",
                                      {
                                        on: {
                                          input: function ($event) {
                                            return _vm.handleSingleSelectChange(
                                              scope.row
                                            )
                                          },
                                        },
                                        model: {
                                          value: scope.row.checked,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "checked", $$v)
                                          },
                                          expression: "scope.row.checked",
                                        },
                                      },
                                      [_vm._v(_vm._s(" "))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2503412525
                          ),
                        })
                      : _vm._e(),
                    _c("el-table-column", {
                      attrs: { label: "APPID", width: "120", prop: "id" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "渠道名称", prop: "name" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "设备类型",
                        prop: "terminalTypeName",
                        width: "150",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "平台类型",
                        prop: "platformTypeName",
                        width: "150",
                      },
                    }),
                  ],
                  1
                )
              : _c("div", [_c("i", { staticClass: "el-icon-loading" })]),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _vm.multiple
                ? _c("el-col", { attrs: { span: 6 } }, [
                    _c(
                      "div",
                      {
                        staticClass: "select",
                        staticStyle: { "text-align": "left" },
                      },
                      [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "top-start",
                              width: "600",
                              trigger: "click",
                            },
                            model: {
                              value: _vm.showPreview,
                              callback: function ($$v) {
                                _vm.showPreview = $$v
                              },
                              expression: "showPreview",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "popover-title",
                                staticStyle: { position: "relative" },
                              },
                              [
                                _c("span", { staticClass: "title" }, [
                                  _vm._v("已选记录列表"),
                                ]),
                                _c("i", {
                                  staticClass: "el-icon-close",
                                  staticStyle: {
                                    position: "absolute",
                                    right: "10px",
                                    top: "5px",
                                    cursor: "pointer",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.showPreview = false
                                    },
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "popover-header",
                                staticStyle: { position: "relative" },
                              },
                              [
                                _c("span", { staticClass: "desc" }, [
                                  _vm._v("已选择（"),
                                  _c("i", [_vm._v(_vm._s(_vm.selectedNum))]),
                                  _vm._v("）"),
                                ]),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "mini" },
                                    on: { click: _vm.handleClear },
                                  },
                                  [_vm._v("全部移除")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "preview-table-container" },
                              [
                                _c(
                                  "lb-table",
                                  {
                                    attrs: {
                                      data: _vm.selectedChannels,
                                      height: 300,
                                      keeps: 9999,
                                    },
                                  },
                                  [
                                    _c("lb-table-column", {
                                      attrs: {
                                        label: "APPID",
                                        width: "120",
                                        prop: "id",
                                      },
                                    }),
                                    _c("lb-table-column", {
                                      attrs: {
                                        label: "应用名称",
                                        prop: "name",
                                      },
                                    }),
                                    _c("lb-table-column", {
                                      attrs: {
                                        label: "操作",
                                        prop: "platformTypeName",
                                        width: "150",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      type: "text",
                                                      size: "mini",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleDelSelection(
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("移除")]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        387424473
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "reference",
                                staticStyle: {
                                  cursor: "pointer",
                                  display: "inline-block",
                                },
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              [
                                _vm._v("\n              已选择（"),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: _vm.formSize },
                                  },
                                  [_vm._v(_vm._s(_vm.selectedNum))]
                                ),
                                _vm._v("）\n            "),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                    "margin-right": "70px",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: _vm.formSize },
                      on: { click: _vm.handleCancel },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: _vm.formSize, type: "primary" },
                      on: { click: _vm.handleSave },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }